export default __webpack_public_path__ + "static/media/002-paint-bucket.9fb03a4f.svg";